module.exports = __webpack_public_path__ + "static/img/20210410.0744f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20210410.jpg
// module id = Apsy
// module chunks = 99